<template>
  <card-seplag :titulo="'Agenda'" cor="#00acc1" >
    <AgendaSeplag :dados.sync="eventos" />
  </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import AgendaSeplag from '@/template/AgendaSeplag.vue'
import { baseApiUrl } from '@/config/global'


export default {
  name:"AgendaTeste",
	components: { AgendaSeplag, CardSeplag},
    data: function(){
        return {
          eventos: [],
          apiUrlRecurso: "programacaoafastamentos",
          exibirTela: false,
          modoEdicao: 'adicionar'
        }
    },
    methods: {        
      carregarDados(){

        this.urlPaginacao = `${this.apiUrlRecurso}/chefia/geral/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}/${this.$store.getters.getIdenPessoa}`
        this.$http.get(`${baseApiUrl}/${this.urlPaginacao}`).then(res => {
            for (let element of res.data) {
              let dataInit = element.dataInicio.split('/')
              let dataFim = element.dataFim.split('/')
              if(element.status.idenStatusProgramacao == 1){
                let novo = {
                  "id": element.id,
                  "title": element.title+" "+ element.nome,
                  "start": dataInit[2]+'-'+dataInit[1]+"-"+dataInit[0],
                  "end":  dataFim[2]+'-'+dataFim[1]+"-"+dataFim[0],
                  "backgroundColor": '#EE7600',
                  "textColor": "#e0e0e0",
                  "description": element.nome
                }
                this.eventos.push(novo)
              }else if(element.status.idenStatusProgramacao == 2){
                  let novo = {
                  "id": element.id,
                  "title": element.title+" "+ element.nome,
                  "start": dataInit[2]+'-'+dataInit[1]+"-"+dataInit[0],
                  "end":  dataFim[2]+'-'+dataFim[1]+"-"+dataFim[0],
                  "backgroundColor": '#0ca852',
                  "textColor": "#e0e0e0",
                  "description": element.nome
                  }
                this.eventos.push(novo)
              }
            }
        })
      }
    },
    mounted(){
      // Carrega os dados do serviço
      this.carregarDados()
    }
    

}
</script>

<style>

</style>